import { Fragment } from 'react';
import { RespostasI } from '../../interfaces/form-flow';
import ButtonActions from './ButtonActions';
import { RestitutionSelected } from './types';

type EvaluationData = {
  avaliacao_atendimento: number;
  avaliacao_informacao: number;
  comentario_atendimento: null | string;
  comentario_informacao: null | string;
  id: string;
  pendente: boolean;
} | null;

type RestitutionData = {
  anexos_restituicao: [];
  historico: number;
  id: string;
  respondido: boolean;
  resposta: string | null;
  solicitacao: number;
};

type Props = {
  request: RespostasI;
  onLoadRequests: ({ page }: { page?: number }) => void;
  onViewDetails?: () => void;
  handleOpenModal?: () => void;
  onOpenModalCancel?: () => void;
  setRequestId?: (value: number) => void;
  evaluationData?: EvaluationData;
  restitutionData?: RestitutionData[] | null;
  setDataRestitution?: (value: RestitutionSelected) => void;
  compact?: boolean;
};

export default function SolicitacaoActions({
  request,
  onLoadRequests,
  onViewDetails,
  handleOpenModal,
  onOpenModalCancel,
  setRequestId,
  evaluationData,
  restitutionData,
  setDataRestitution,
  compact = false,
}: Props): JSX.Element {
  return (
    <Fragment>
      <ButtonActions
        request={request}
        onLoadRequests={onLoadRequests}
        onViewDetails={onViewDetails}
        handleOpenModal={handleOpenModal}
        onOpenModalCancel={onOpenModalCancel}
        setRequestId={setRequestId}
        evaluationData={evaluationData}
        restitutionData={restitutionData}
        setDataRestitution={setDataRestitution}
        compact={compact}
      />
    </Fragment>
  );
}

export { default as DocumentosParaAssinaturaSection } from './DocumentosParaAssinaturaSection';
export { default as AssinarDocumentosDialogHost } from './AssinarDocumentosDialogHost';
export type { RestitutionSelected } from './types';
